{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "type": "object",
  "properties": {
    "server": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "port": { "$ref": "#/definitions/port" },
        "host": { "type": "string" },
        "write_timeout": { "$ref": "#/definitions/timestring" },
        "read_timeout": { "$ref": "#/definitions/timestring" },
        "shutdown_delay": { "$ref": "#/definitions/timestring" },
        "sentry_environment": { "type": "string", "pattern": "production|staging|development" },
        "sentry_enabled": { "type": "boolean", "default": true }
      },
      "required": ["port", "host"]
    },
    "PPROF": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "enabled": { "type": "boolean" },
        "port": { "$ref": "#/definitions/port" },
        "host": { "type": "string" }
      }
    },
    "proxy": { "$ref": "#/definitions/proxy" },
    "redis": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "url": { "type": "string" },
        "timeout": { "type": "string", "pattern": "^\\d+(ms|s)$" },
        "pool_size": { "type": "integer" },
        "min_idle_conns": { "type": "integer" },
        "max_active_connections": { "type": "integer" }
      }
    },
    "internal_services": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "tx_gateway_url": { "type": "string" }
      }
    },
    "web3": { "$ref": "#/definitions/web3" },
    "override": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "plans": {
          "type": "object",
          "patternProperties": {
            "internal|free|enterprise|startup|pro|business|custom": {
              "$ref": "#/definitions/overrideEntity",
              "required": ["subscriptionCallLimit"]
            }
          }
        }
      },
      "anyOf": [{ "required": ["plans"] }, { "required": ["organizations"] }]
    },
    "fallback": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "realtime": { "$ref": "#/definitions/realtimeLimit" },
        "ws": { "$ref": "#/definitions/wsLimit" },
        "subscriptionCallLimit": { "type": "integer" }
      },
      "required": ["realtime", "subscriptionCallLimit"]
    },
    "metrics": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "port": { "type": "integer" },
        "read_timeout": { "type": "string", "pattern": "^\\d+[smh]$" },
        "write_timeout": { "type": "string", "pattern": "^\\d+[smh]$" }
      },
      "required": ["port"]
    }
  },
  "required": ["server", "metrics", "proxy", "override", "web3", "fallback"],
  "definitions": {
    "port": {
      "type": "integer",
      "minimum": 1,
      "maximum": 65535
    },
    "timestring": {
      "type": "string",
      "pattern": "^\\d+[smh]$"
    },
    "proxy": {
      "type": "array",
      "items": {
        "type": "object",
        "additionalProperties": false,
        "properties": {
          "path": { "type": "string" },
          "rewrite": {
            "type": "array",
            "items": { "type": "string" }
          },
          "target": {
            "type": "object",
            "properties": {
              "type": { "type": "string", "enum": ["url", "nats"] }
            },
            "required": ["type"],
            "if": {
              "properties": {
                "type": { "const": "url" }
              }
            },
            "then": {
              "properties": {
                "url": { "type": "string" }
              },
              "required": ["url"]
            }
          },
          "restrict": { "type": "boolean" },
          "auth": {
            "type": "object",
            "description": "If the auth object is present, the request will be authenticated using the provided credentials",
            "additionalProperties": false,
            "properties": {
              "type": {
                "type": "string",
                "enum": ["header", "query", "url"]
              },
              "key": { "type": "string" },
              "value": { "type": "string" }
            },
            "anyOf": [
              {
                "if": {
                  "properties": {
                    "type": { "const": "header" }
                  }
                },
                "then": {
                  "required": ["key", "value"]
                }
              },
              {
                "if": {
                  "properties": {
                    "type": { "const": "query" }
                  }
                },
                "then": {
                  "required": ["key", "value"]
                }
              },
              {
                "if": {
                  "properties": {
                    "type": { "const": "url" }
                  }
                },
                "then": {
                  "required": ["value"]
                }
              }
            ]
          },
          "product": {
            "uniqueItems": true,
            "type": "string",
            "enum": [
              "default",
              "orderbook",
              "swap",
              "fusion",
              "fusion-plus",
              "balance",
              "price",
              "token",
              "tx-gateway",
              "portfolio",
              "gas-price",
              "charts",
              "nft",
              "traces",
              "history",
              "web3",
              "domains",
              "token-details",
              "blacklist",
              "airdrop-tx-signer",
              "news",
              "crypto-purchase",
              "history-aggregator",
              "wallet-push",
              "swap-builder",
              "location-signs",
              "data-distributor",
              "governance"
            ]
          }
        },
        "allOf": [
          {
            "if": {
              "allOf": [
                {
                  "not": {
                    "type": "object",
                    "properties": {
                      "auth": { "type": "null" }
                    }
                  }
                },
                {
                  "properties": {
                    "auth": {
                      "type": "object",
                      "properties": {
                        "type": { "const": "url" }
                      }
                    }
                  }
                }
              ]
            },
            "then": {
              "properties": {
                "target": {
                  "type": "object",
                  "properties": {
                    "type": { "const": "url" },
                    "url": { "type": "string", "pattern": "\\{auth\\}" }
                  }
                }
              }
            }
          },
          {
            "anyOf": [
              {
                "if": {
                  "properties": {
                    "restrict": { "const": false }
                  }
                },
                "then": {
                  "required": ["path", "target"]
                }
              },
              {
                "if": {
                  "properties": {
                    "restrict": { "const": true }
                  }
                },
                "then": {
                  "required": ["path"]
                }
              }
            ]
          }
        ]
      }
    },
    "realtimeLimit": {
      "type": "object",
      "additionalProperties": false,
      "description": "Realtime limit configuration",
      "properties": {
        "calls": { "type": "integer" },
        "window": {
          "type": "string",
          "pattern": "^\\d+[smh]$",
          "description": "The window how we calculate the amount of calls. It can be something like 1s, 60s, 1m or 1h. We only support seconds, minutes and hours"
        }
      },
      "required": ["calls", "window"]
    },
    "wsLimit": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "realtime": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "calls": { "type": "integer" },
            "window": { "type": "string", "pattern": "^\\d+[smh]$" }
          },
          "required": ["calls", "window"]
        },
        "connections_limit": { "type": "integer" }
      }
    },
    "overrideEntity": {
      "type": "object",
      "properties": {
        "proxy": {
          "$ref": "#/definitions/proxy"
        },
        "fees": {
          "description": "Fees configuration for our api usage on swaps",
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "enableCustomerFeeClassic": {
              "type": "boolean",
              "description": "Enable fee collection for classic swaps via api param for customer"
            },
            "enableCustomerFeeFusion": {
              "type": "boolean",
              "description": "Enable fee collection for fusion swaps via api param for customer"
            },
            "normalPairFee": {
              "type": "number",
              "minimum": 0,
              "maximum": 10,
              "description": "fee for stable coins in %, max 10%",
              "errorMessage": {
                "minimum": "Normal pair fee must be greater than 0",
                "maximum": "Normal pair fee must be less than than 10"
              }
            },
            "stablePairFee": {
              "type": "number",
              "minimum": 0,
              "maximum": 10,
              "description": "fee for stable coins in %, max 10%",
              "errorMessage": {
                "minimum": "Stable pair fee must be greater than 0",
                "maximum": "Stable pair fee must be less than than 10"
              }
            }
          },
          "required": ["enableCustomerFeeClassic", "enableCustomerFeeFusion", "normalPairFee", "stablePairFee"]
        },
        "limits": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
              "products": {
                "description": "List of products that will have the limits applied as group (if multiple products are assigned we generate a bundle",
                "type": "array",
                "minItems": 1,
                "uniqueItems": true,
                "items": {
                  "type": "object",
                  "properties": {
                    "name": {
                      "enum": [
                        "default",
                        "orderbook",
                        "swap",
                        "fusion",
                        "fusion-plus",
                        "balance",
                        "price",
                        "token",
                        "tx-gateway",
                        "portfolio",
                        "gas-price",
                        "nft",
                        "traces",
                        "history",
                        "web3",
                        "domains",
                        "token-details",
                        "blacklist",
                        "airdrop-tx-signer",
                        "news",
                        "crypto-purchase",
                        "history-aggregator",
                        "wallet-push",
                        "swap-builder",
                        "location-signs",
                        "data-distributor",
                        "governance"
                      ]
                    }
                  },
                  "required": ["name"]
                }
              },
              "realtime": { "$ref": "#/definitions/realtimeLimit" },
              "subscriptionCallLimit": {
                "type": "integer",
                "description": "The monthly subscription usage limit allowed for this product group"
              }
            },
            "required": ["realtime", "products"]
          }
        },
        "ws": { "$ref": "#/definitions/wsLimit" }
      },
      "required": ["fees"]
    },
    "web3": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "default_timeout": { "type": "string", "pattern": "^\\d+(ms|s)$" },
        "chains": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
              "chain_ids": {
                "type": "array",
                "items": { "type": "integer" }
              },
              "methods": {
                "type": "array",
                "items": {
                  "type": "object",
                  "additionalProperties": false,
                  "properties": {
                    "name": { "type": "string" },
                    "timeout": { "type": "string", "pattern": "^\\d+(ms|s)$" },
                    "protocols": {
                      "type": "array",
                      "items": {
                        "type": "string",
                        "enum": ["http", "ws"]
                      }
                    }
                  },
                  "required": ["name", "protocols"]
                }
              }
            },
            "required": ["chain_ids", "methods"]
          }
        }
      },
      "required": ["default_timeout", "chains"]
    }
  }
}
